import { put, takeLatest, takeEvery } from 'redux-saga/effects';
import axios from 'axios';

function* fetchReferralPartners() {
    const response = yield axios.get(`/api/referral-partners`);
    console.log(`Response.data is:`, response.data);
    yield put({ type: 'SET_REFERRALS', payload: response.data });
}

function* addReferralPartnerSaga(action) {
    try {
        yield axios.post('/api/referral-partners', {
            name: action.payload.referralName,
            phone: action.payload.referralPhone,
            code: action.payload.referralCode,
        });
        yield put({ type: 'FETCH_REFERRALS' });
    } catch (error) {
        console.log('Error in add', error);
    };
};

function* updateReferralPartnerSaga(action) {
    try {
        console.log(action.payload)
        yield axios.put(`/api/referral-partners/${action.payload.id}`, action.payload);
        yield put({ type: 'FETCH_REFERRALS' });
    } catch (error) {
        console.log('Error updating request', error);
    }
}

function* deleteReferralPartnerSaga(action) {
    try {
        console.log(`Payload in saga is: ${action.payload}`);
        yield axios.delete(`/api/referral-partners/${action.payload}`);
        yield put({ type: 'FETCH_REFERRALS' });
    } catch (error) {
        console.log('Error deleting referral', error);
    }
}

function* referralPartnerSaga() {
    yield takeLatest('FETCH_REFERRALS', fetchReferralPartners);
     yield takeEvery('ADD_REFERRAL_PARTNER', addReferralPartnerSaga);
     yield takeEvery('DELETE_REFERRAL_PARTNER',deleteReferralPartnerSaga);
     yield takeEvery('UPDATE_REFERRAL_PARTNER', updateReferralPartnerSaga);

}

export default referralPartnerSaga;